(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["goal-hydration-quiz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('goal-hydro-quiz')) {
    customElements.define('goal-hydro-quiz', class GoalHydroQuiz extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.base = (parseFloat(this.dataset.base) || 2000) / 1000;
        this.tube = parseInt(this.dataset.tube, 10) || 20;
        this.bottleMl = parseInt(this.dataset.bottle, 10) || 500;
        this.near = parseInt(this.dataset.near, 10) || 75;
        this.low = Math.min(this.near - 1, parseInt(this.dataset.low, 10) || 50);
        this.groups = [...this.querySelectorAll('[data-q]')];
        this.groups.forEach((group) => {
          const buttons = [...group.querySelectorAll('button')];
          if (!buttons.length) return;
          if (!group.querySelector('[aria-pressed="true"]')) buttons[0].setAttribute('aria-pressed', 'true');
          buttons.forEach((btn) => {
            btn.addEventListener('click', () => {
              buttons.forEach((b) => b.setAttribute('aria-pressed', b === btn));
              this.render();
            });
          });
        });
        this.render();
      }

      litres(n) { return (Math.round(n * 10) / 10).toFixed(1) + ' L'; }

      fill(template, values) {
        return (template || '').replace(/\[(\w+)\]/g, (match, key) => (key in values ? values[key] : match));
      }

      render() {
        let have = 0;
        let extra = 0;
        this.groups.forEach((group) => {
          const selected = group.querySelector('[aria-pressed="true"]');
          if (!selected) return;
          const litres = (parseFloat(selected.dataset.v) || 0) / 1000;
          if (group.dataset.kind === 'extra') extra += litres;
          else have += litres;
        });

        const target = this.base + extra;
        const pct = target > 0 ? Math.min(100, Math.round((have / target) * 100)) : 100;
        const gap = Math.max(0, target - have);
        const bottles = Math.ceil(gap / (this.bottleMl / 1000));
        const values = {
          bottles,
          n: bottles,
          bottle: this.bottleMl,
          tube: this.tube,
          days: bottles ? Math.floor(this.tube / bottles) : this.tube,
          target: this.litres(target),
          have: this.litres(have),
          gap: this.litres(gap),
          pct: pct + '%',
          s: bottles === 1 ? '' : 's'
        };
        const band = pct >= 100 ? 'full' : pct >= this.near ? 'near' : pct >= this.low ? 'low' : 'empty';
        const cap = band.charAt(0).toUpperCase() + band.slice(1);

        const arc = this.querySelector('[data-arc]');
        if (arc) arc.setAttribute('stroke-dashoffset', 100 - pct);
        const needle = this.querySelector('[data-needle]');
        if (needle) needle.style.transform = `rotate(${-90 + pct * 1.8}deg)`;
        const pctEl = this.querySelector('[data-pct]');
        if (pctEl) pctEl.textContent = pct + '%';
        const line = this.querySelector('[data-line]');
        if (line) line.textContent = this.fill(this.dataset.targetLine, values);

        const verdict = this.querySelector('[data-verdict]');
        if (verdict) {
          verdict.textContent = this.fill(this.dataset['band' + cap], values);
          this.querySelector('[data-verdict-sub]').textContent = this.fill(this.dataset['text' + cap], values);
        }

        const cta = this.querySelector('[data-cta-btn]');
        if (cta) {
          const label = this.dataset[band + 'Cta'] || (band === 'full' ? this.dataset.ctaDone : this.dataset.cta);
          cta.textContent = this.fill(label, values);
          const variantInput = this.querySelector('[data-cta-variant]');
          if (variantInput) {
            const variant = this.dataset[band + 'Variant'];
            if (variant) variantInput.value = variant;
          } else if (cta.tagName === 'A' && this.dataset[band + 'Url']) {
            cta.setAttribute('href', this.dataset[band + 'Url']);
          }
        }

        this.dispatchEvent(new CustomEvent('goal:quiz-result', {
          bubbles: true,
          detail: { pct, band, target, have, bottles }
        }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goal-stat-bars"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('goal-stat-bars')) {
    customElements.define('goal-stat-bars', class GoalStatBars extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        // Wait until the bars inside this element have been parsed (matters when several of these sections are on one page)
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      init() {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce || this.dataset.animate === 'false') return;

        this.duration = parseInt(this.dataset.duration, 10) || 1400;
        this.stagger = parseInt(this.dataset.stagger, 10) || 200;
        this.classList.add('is-ready');
        this.zeroNumbers();

        const inEditor = window.Shopify && window.Shopify.designMode;
        if (this.dataset.trigger === 'load' || inEditor || !('IntersectionObserver' in window)) {
          requestAnimationFrame(() => requestAnimationFrame(() => this.play()));
          return;
        }
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.play();
              if (this.dataset.replay !== 'true') this.observer.disconnect();
            } else if (this.dataset.replay === 'true') {
              this.reset();
            }
          });
        }, { threshold: 0.35 });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.frames && this.frames.forEach((id) => cancelAnimationFrame(id));
      }

      get nums() { return [...this.querySelectorAll('[data-num]')]; }

      zeroNumbers() {
        if (this.dataset.count === 'true') this.nums.forEach((el) => { el.textContent = '0'; });
      }

      play() {
        if (this.classList.contains('is-in')) return;
        this.classList.add('is-in');
        if (this.dataset.count === 'true') this.countUp();
      }

      reset() {
        this.classList.remove('is-in');
        this.frames && this.frames.forEach((id) => cancelAnimationFrame(id));
        this.zeroNumbers();
      }

      countUp() {
        const ease = (t) => 1 - Math.pow(1 - t, 3);
        this.frames = [];
        this.nums.forEach((el) => {
          const row = el.closest('[data-index]');
          const index = row ? parseInt(row.dataset.index, 10) || 0 : 0;
          const target = parseInt(el.dataset.to, 10) || 0;
          const startAt = performance.now() + index * this.stagger;
          const step = (now) => {
            const progress = Math.min(1, Math.max(0, (now - startAt) / this.duration));
            el.textContent = Math.round(target * ease(progress));
            if (progress < 1) this.frames.push(requestAnimationFrame(step));
          };
          this.frames.push(requestAnimationFrame(step));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
